import { compact } from 'lodash';

function generateGoals(values: DistanceType[]): GoalType[] {
  const waves = values.map((distance) => distance.goal);
  return compact(waves);
}

export { generateGoals };
